import React from 'react';
import { Responsive } from 'react-admin';
import { AppLogo } from './AppLogo';

export const PageTitle = ({ record, title }) => (
  <Responsive
    xsmall={
      <AppLogo>
        <span>{` ${title}`}</span>
      </AppLogo>
    }
    medium={<span>{title}</span>}
  />
);

export { AppLogo };



// WEBPACK FOOTER //
// ./src/components/common/index.js